import React from 'react';

import { Grid } from '@material-ui/core';
import { Icon, Button } from 'semantic-ui-react';
import {
  EmailShareButton,
  FacebookShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  LinkedinShareButton,
} from 'react-share';
import PubSub from 'pubsub-js';
import * as R from 'ramda';

import RegistrationTopic from '../topics/RegistrationPage.topic';
import { useBreakpoints } from '$app/common/utils/mediaQueries';
import { renderMetaTags } from '$app/common/utils/SeoMetaTags';
import { withErrorBoundary } from '$app/modules/common/ErrorBoundary';
import CompanyListContainer from '../containers/CompanyList.container';

const URL = 'https://tesavirtualfair.snaphunt.com/';

const RegistrationPage = () => {
  const { isSmDown, isXsDown, isMdDown } = useBreakpoints();

  return (
    <>
      {renderMetaTags('/')}
      <div
        css={{
          maxWidth: 1200,
          margin: '0 auto',
          paddingLeft: isSmDown ? 30 : 0,
          paddingRight: isSmDown ? 30 : 0,
        }}
      >
        <Grid container spacing={2}>
          {isMdDown ? null : (
            <div
              css={{
                content: '',
                position: 'absolute',
                width: '70px',
                height: '90px',
                top: '310px',
                left: -10,
                display: 'block',
                backgroundColor: 'transparent',
                backgroundImage: 'radial-gradient(lightGray 14%,transparent 0)',
                backgroundSize: '15px 15px',
                backgroundPosition: '15px 15px,15px 15px',
                zIndex: 1,
              }}
            />
          )}

          <Grid item xs={12} sm={12} md={6} lg={6}>
            <div css={{ marginTop: isSmDown ? 0 : 50 }}>
              <img
                src="https://images.snaphunt.com/assets/images/tesavirtualfair-logo.svg"
                alt="CompanyLogo"
                css={{
                  width: isXsDown ? 100 : isSmDown ? 150 : 'auto',
                  height: 60,
                }}
              />
              <img
                src="https://images.snaphunt.com/assets/images/event-dates.svg"
                alt="CompanyLogo"
                css={{
                  marginLeft: 20,
                  width: isSmDown ? 150 : 'auto',
                  height: 60,
                }}
              />
            </div>
            <div css={{ marginTop: 30 }}>
              <h1
                className="ui header"
                css={{
                  color: '#333333 !important',
                }}
              >
                Find opportunities with exciting employers
              </h1>
              <p css={{ fontSize: 16, lineHeigth: 24, color: '#333333' }}>
              TeSA Virtual Fair is now live. View and apply to jobs today!
              </p>
            </div>
            <div
              css={{
                display: 'flex',
                marginTop: 30,
              }}
            >
              <Button
                onClick={() => PubSub.publish(RegistrationTopic.OPEN)}
                type="button"
                css={{
                  '&:hover': {
                    filter: 'brightness(85%)',
                  },
                  color: 'white !important',
                  width: 160,

                  height: 60,
                  background: '#6C2D8A !important',
                }}
              >
                View jobs
              </Button>
              <p
                css={{
                  fontFamily: 'Roboto',
                  fontWeight: 400,
                  fontSize: 13,
                  margin: 0,
                  padding: 0,
                  alignSelf: 'center',
                  color: 'gray',
                  marginLeft: 10,
                }}
              >
                Share
              </p>
              <FacebookShareButton url={URL}>
                <div
                  css={{ alignSelf: 'center', marginLeft: isXsDown ? 4 : 10 }}
                >
                  <Icon name="sh-logo-facebook-2" css={{ color: 'gray' }} />
                </div>
              </FacebookShareButton>
              <TwitterShareButton url={URL}>
                <div
                  css={{ alignSelf: 'center', marginLeft: isXsDown ? 4 : 10 }}
                >
                  <Icon name="sh-logo-twitter-2" css={{ color: 'gray' }} />
                </div>
              </TwitterShareButton>
              <LinkedinShareButton url={URL}>
                <div
                  css={{ alignSelf: 'center', marginLeft: isXsDown ? 4 : 10 }}
                >
                  <Icon name="sh-logo-linkedin-2" css={{ color: 'gray' }} />
                </div>
              </LinkedinShareButton>
              <EmailShareButton
                subject="Hey! Thought you might find this interesting:"
                body="Hey! Thought you might find this interesting:"
                url={URL}
              >
                <div
                  css={{ alignSelf: 'center', marginLeft: isXsDown ? 4 : 10 }}
                >
                  <Icon name="sh-email-2" css={{ color: 'gray' }} />
                </div>
              </EmailShareButton>
              <WhatsappShareButton url={URL}>
                <div css={{ alignSelf: 'center', marginLeft: 10 }}>
                  <Icon name="sh-logo-whatsapp-2" css={{ color: 'gray' }} />
                </div>
              </WhatsappShareButton>
            </div>
          </Grid>

          {isSmDown ? null : (
            <Grid item md={6} lg={6} xl={6}>
              <img
                css={{ marginTop: -80 }}
                src="https://images.snaphunt.com/assets/images/registration_banner.svg"
                className="ui fluid image"
                alt="stockImage"
              />
            </Grid>
          )}
        </Grid>
      </div>

      <CompanyListContainer />
    </>
  );
};

export default R.compose(withErrorBoundary)(RegistrationPage);
